import { render, staticRenderFns } from "./summary-table.vue?vue&type=template&id=1c417da4&scoped=true"
import script from "./summary-table.vue?vue&type=script&lang=js"
export * from "./summary-table.vue?vue&type=script&lang=js"
import style0 from "./summary-table.vue?vue&type=style&index=0&id=1c417da4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c417da4",
  null
  
)

export default component.exports